import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "./firebase";

export const useAnalyticsPageView = () => {
  const location = useLocation();
  useEffect(() => {
    logPageView(location);
  }, [location]);
};
